import React, {Component} from 'react'
import { Modal } from "react-bootstrap"

import styled from "styled-components"
import ProviderSearchCriteria from "manager/views/components/Settlement/SelectNewProvider/SearchCriteria"
import ProviderSearchResults from "manager/views/components/Settlement/SelectNewProvider/SearchResults"
import {
  fetchSettlementProviderSearchConfig,
  searchQualiaSettlementAgencies
} from "manager/redux/settlement_provider_search"
import {createStructuredSelector} from "reselect"
import {
  selectAgentOpId,
  selectAssignmentTransactionHash,
  selectTransactionOpId
} from "manager/selectors/referral_selectors"
import {connect} from "react-redux"

import {
  MAX_MOBILE_PX,
} from "manager/views/components/Settlement/constants";
import NoQualiaMatch from "manager/views/components/Settlement/SelectNewProvider/NoQualiaMatch"
import {selectSearchResults} from "manager/selectors/settlement_provider_search_selectors"
import UpdateAddress from "manager/views/components/Settlement/SelectNewProvider/UpdateAddress"
import MoreInfo from "manager/views/components/Settlement/SelectNewProvider/MoreInfo";
import {segmentEventTracker} from "common/analytics"

const SelectNewSettlementProviderContainer = styled.div`
  color: #4A4A4A;
  font-family: "Circular", sans-serif;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: #F1F1F4;

  a {
    color: #0588DD;
  }
`

const MoreInfoModal = styled(Modal)`
  .modal-content {
    border-radius: 16px;
  }
`

/**
 * Card for selecting a new settlement provider when no prior selection exists.
 */
class SelectNewSettlementProvider extends Component {
  state = {
    updateAddressView: false,
    showMoreInfo: false
  }

  componentDidMount() {
    const {hash, dispatch} = this.props
    if (hash) {
      dispatch(fetchSettlementProviderSearchConfig(hash, null))
    }
  }

  handleSearch = _.debounce(async (filter_by_name) => {
    const {transaction_op_id, agent_op_id} = this.props
    segmentEventTracker('Qualia-Provider Search', {'transaction_op_id': transaction_op_id, 'agent_op_id': agent_op_id})
    await this.props.dispatch(searchQualiaSettlementAgencies(filter_by_name))
  }, 800)

  setUpdateAddressView = (updateAddressView) => {
    this.setState({updateAddressView})
  }

  setShowMoreInfo = (showMoreInfo) => {
    this.setState({showMoreInfo})
  }

  isMobileSize = () => {
    return window.innerWidth < MAX_MOBILE_PX
  }

  render() {
    const {searchResults} = this.props

    if (this.state.updateAddressView) {
        return (
          <SelectNewSettlementProviderContainer>
            <UpdateAddress setUpdateAddressView={this.setUpdateAddressView} />
          </SelectNewSettlementProviderContainer>
        )
    }

    if (this.state.showMoreInfo && this.isMobileSize()) {
      return (
        <SelectNewSettlementProviderContainer>
          <MoreInfo showMoreInfo={this.setShowMoreInfo} isMobile={this.isMobileSize()} />
        </SelectNewSettlementProviderContainer>
      )
    }

    return (
      <SelectNewSettlementProviderContainer>
        {this.state.showMoreInfo && (
          <MoreInfoModal show={!this.isMobileSize()}>
            <MoreInfo showMoreInfo={this.setShowMoreInfo} isMobile={this.isMobileSize()}/>
          </MoreInfoModal>
        )}
        <ProviderSearchCriteria onChange={this.handleSearch}
                                setShowMoreInfo={this.setShowMoreInfo}
                                setUpdateAddressView={this.setUpdateAddressView}/>
        {(searchResults && searchResults.length > 0) && (
          <ProviderSearchResults/>
        )}
        {(searchResults && searchResults.length === 0) && (
          <NoQualiaMatch/>
        )}
      </SelectNewSettlementProviderContainer>
    )
  }
}

const selector = createStructuredSelector({
  hash: selectAssignmentTransactionHash,
  searchResults: selectSearchResults,
  transaction_op_id: selectTransactionOpId,
  agent_op_id: selectAgentOpId,
})

export default connect(selector)(SelectNewSettlementProvider)
